import React, { useContext, useState, useEffect } from "react";
import ListUserComponent from "./ListUserComponent";
import { AppContext } from "context/AppContext";
import { useFormik } from "formik";
import { GET_USERS } from "constant/endpoints";

function ListUserContainer() {
  const { api, account } = useContext(AppContext);
  const [users, setUsers] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  //console.log(account);

  const pageSize = 8;

  //Si el campo de busqueda esta vacío
  useEffect(() => {
    if (search.trim() === "") {
      api(`${GET_USERS}?page=${page}&page_size=${pageSize}`)
        .then(({ ok, body }) => {
          if (ok) {
            setUsers(body.results || body.data);      
            if (body.data_size) {
              setTotalPages(Math.ceil(body.data_size / pageSize));
            }
          }
        });
    }
  }, [page, search]);

  // Si se utiliza el campo de busqueda
  useEffect(() => {
    if (search.trim() !== "") {
      api(`${GET_USERS}?page_size=all`)
        .then(({ ok, body }) => {
          if (ok) {
            const dataList = body.results || body.data;
            
            //Filtro sobre todos los datos al buscar, dado que se perdia la reactividad
            const filtered = dataList.filter((user) => 
              user.full_name?.toLowerCase().includes(search.toLowerCase()) ||
              user.dni?.toLowerCase().includes(search.toLowerCase()) ||
              user.user?.email?.toLowerCase().includes(search.toLowerCase())
            );

            setUsers(filtered);
            setTotalPages(1);
          }
        });
    }
  }, [search]);

  const handleSearchChange = (text) => {
    setSearch(text);
    setPage(1);
  };

  return <ListUserComponent
    users={users}
    page={page}
    setPage={setPage}
    totalPages={totalPages}
    search={search}
    setSearch={handleSearchChange}
    account={account}
  />;
}

export default ListUserContainer;
